export default function GS_Add_Cells() {
  return (
    <div className="p-4">
      <h1>GS Add Cells</h1>
    </div>
  );
}
